import type { DateRangeValue } from "@/app/audit-logs/utils/date-range";
import type {
  AuditAction,
  AuditSource,
  ResourceType,
} from "@/app/audit-logs/utils/enum-helpers";

/**
 * Org-scoped prefix; project and other dimensions live in `params` for list/filterOptions.
 * Use `auditLogsKeys.all(organizationId)` for `invalidateQueries` to refresh every audit-log query under that org.
 */
export const auditLogsKeys = {
  all: (organizationId: string) => ["audit-logs", organizationId] as const,
  list: (params: {
    organizationId: string;
    projectId: string;
    actions?: AuditAction[];
    sources?: AuditSource[];
    resourceTypes?: ResourceType[];
    dateRange?: DateRangeValue;
    cursor?: string;
  }) => [...auditLogsKeys.all(params.organizationId), "list", params] as const,
  filterOptions: (params: {
    organizationId: string;
    projectId: string;
    actions?: AuditAction[];
    sources?: AuditSource[];
    resourceTypes?: ResourceType[];
    dateRange?: DateRangeValue;
  }) =>
    [
      ...auditLogsKeys.all(params.organizationId),
      "filter-options",
      params,
    ] as const,
};
